import {ParentTab} from '@components/ui/tabs/tab';
import {AppParameterMap} from '../../../config/app-parameter-map';
import {TabListEntry} from '@components/ui/tabs/tab-list-entry';

export class TabList {
  readonly entries: TabListEntry[];

  constructor(tabs: ParentTab[], appParams: AppParameterMap = AppParameterMap.empty()) {
    this.entries = this.convertTabsToEntries(tabs, appParams);
  }

  private convertTabsToEntries(tabs: ParentTab[], appParams: AppParameterMap): TabListEntry[] {
    if (!tabs) {
      return [];
    }

    return tabs.map(tab => this.convertTabToEntry(tab, appParams));
  }

  private convertTabToEntry(tab: ParentTab, appParams: AppParameterMap): TabListEntry {
    const routerLinkCommands = tab.appRoute.toRouterLinkCommands(appParams);
    const childEntries = this.convertTabsToEntries(tab.children, appParams);

    return {
      id: tab.id,
      title: tab.title,
      routerLinkCommands: routerLinkCommands,
      children: childEntries
    };
  }
}
